import { Button, Spin } from 'antd'
import { Wrapper } from './styled'

interface IProps {
  primaryText?: string
  primaryAction?: () => void
  disablePrimaryButton?: boolean
  secondaryText: string
  secondaryAction: () => void
  disableSecondaryButton?: boolean
  secondaryIsPrimary?: boolean
  isDangerous?: boolean
  processing?: boolean
}

export const ModalButtons = ({
  primaryText,
  primaryAction,
  disablePrimaryButton,
  secondaryText,
  secondaryAction,
  disableSecondaryButton,
  secondaryIsPrimary = false,
  isDangerous = false,
  processing = false,
}: IProps) => {
  return (
    <Wrapper
      isdangerous={String(isDangerous)}
      secondaryIsPrimary={String(secondaryIsPrimary)}
    >
      <Button disabled={disableSecondaryButton} onClick={secondaryAction}>
        {secondaryText}
      </Button>
      {primaryAction && (
        <Spin spinning={processing}>
          <Button disabled={disablePrimaryButton} onClick={primaryAction}>
            {primaryText}
          </Button>
        </Spin>
      )}
    </Wrapper>
  )
}
